import { render, staticRenderFns } from "./userPwdEdit.vue?vue&type=template&id=e5ae806c&scoped=true"
import script from "./userPwdEdit.vue?vue&type=script&lang=js"
export * from "./userPwdEdit.vue?vue&type=script&lang=js"
import style1 from "./userPwdEdit.vue?vue&type=style&index=1&id=e5ae806c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ae806c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5ae806c')) {
      api.createRecord('e5ae806c', component.options)
    } else {
      api.reload('e5ae806c', component.options)
    }
    module.hot.accept("./userPwdEdit.vue?vue&type=template&id=e5ae806c&scoped=true", function () {
      api.rerender('e5ae806c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/userPwdEdit.vue"
export default component.exports